export const ADDED = "ADDED";
export const PRISTINE = "PRISTINE";
export const DIRTY = "DIRTY";
export const DELETED = "DELETED";
